import { createStore, createEvent, createEffect, sample } from "effector";
import { DashboardState, DashboardResponse } from "../types/homePageTypes";
import { homeService } from "../service/api";
import { updateCallBookmark } from "@/features/calls/store";

export const fetchDashboardRequested = createEvent();

export const fetchDashboardFx = createEffect(
  async (): Promise<DashboardResponse> => {
    return await homeService.getDashboard();
  },
);

export const $homeStore = createStore<DashboardState>({
  dashboard: null,
  loading: false,
  error: null,
});

$homeStore
  .on(fetchDashboardRequested, (state) => ({
    ...state,
    loading: true,
    error: null,
  }))
  .on(fetchDashboardFx.doneData, (state, dashboard) => ({
    ...state,
    dashboard,
    loading: false,
    error: null,
  }))
  .on(fetchDashboardFx.failData, (state, error) => ({
    ...state,
    loading: false,
    error: error.message,
  }))
  .on(updateCallBookmark, (state, { callId, isBookmarked }) => {
    if (!state.dashboard) return state;
    return {
      ...state,
      dashboard: {
        ...state.dashboard,
        calls_for_you: state.dashboard.calls_for_you.map((call) =>
          call.id === callId
            ? { ...call, is_call_bookmarked: isBookmarked }
            : call,
        ),
      },
    };
  });

sample({
  clock: fetchDashboardRequested,
  target: fetchDashboardFx,
});
